<template>
  <el-dialog
    title="仪器信息添加"
    :visible.sync="state"
    width="60%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <!-- 筛选 -->
    <el-row>
      <el-col :span="9">
        <el-input
          placeholder="请输入检测仪器名称"
          v-model="searchValue"
          clearable
          class="input-with-select"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="valueSearch"
          ></el-button>
        </el-input>
      </el-col>
    </el-row>
    <!-- 筛选 -->

    <!-- 表格 -->
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <template v-for="(item, index) in columns">
        <!-- 默认 -->
        <el-table-column
          :key="index"
          v-if="item.field"
          :label="item.title"
          :prop="item.field"
          :width="item.width"
          sortable
        >
        </el-table-column>

        <!-- 默认 end -->
        <!-- 自定义 -->
        <el-table-column
          :label="item.title"
          :key="index + 1"
          :width="item.width"
          v-else
        >
          <template slot-scope="scope">
            <!-- switch v-model="scope.row.state" -->
            <el-switch
              v-if="item.type === 'switch'"
              v-model="scope.row[item.payload.field]"
              @change="item.payload.change(scope.row)"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
            <!-- switch -->

            <!-- btn -->
            <template v-if="item.type === 'btn'">
              <el-button
                size="mini"
                :type="item.type"
                v-for="(item, index) in item.payload"
                :key="index"
                @click="item.click(scope.row)"
              >
                <span v-if="item.name">{{ item.name }}</span>
                <i v-else :class="item.icon"></i>
              </el-button>
            </template>
            <!-- btn -->
          </template>
        </el-table-column>
        <!-- 自定义 end -->
      </template>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 10, 20, 50, 100]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <div
      v-if="formBtns && formBtns.length"
      class="button-group"
      style="display: flex; justify-content: center"
    >
      <el-button
        v-for="(item, index) in formBtns"
        :key="index"
        :type="item.type"
        :style="{ width: item.width || '70px' }"
        class="form-button"
        @click="submitFn(item.content, item.icon)"
      >
        <i v-if="item.icon" :class="item.icon"></i>
        <span v-else> {{ item.content }}</span>
      </el-button>
    </div>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    page: Number,
    size: Number,
    total: Number,
    user: Object,
    roles: Array,
    tableData: {
      required: true,
      type: Array
    },
    columns: {
      /*
      [
          {title, field, ...}
      ]
      */
      required: true,
      type: Array
    }
  },
  data() {
    return {
      searchValue: '',
      formBtns: [
        {
          content: '确定',
          width: '185px',
          type: 'primary'
        },
        {
          content: '取消',
          width: '185px',
          type: ''
        }
      ]
    }
  },

  methods: {
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val)
    },
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      this.$emit('confirm', formData)
    },
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val)
    },
    valueSearch() {
      this.$emit('valueSearch', this.searchValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-group {
  display: flex;
  justify-content: center;
  .form-button {
    margin: 0 20px;
  }
}
</style>
